import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-otp-for-complete-inspection-preview',
  templateUrl: './otp-for-complete-inspection-preview.component.html',
  styleUrls: ['./otp-for-complete-inspection-preview.component.scss']
})
export class OtpForCompleteInspectionPreviewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
